import { EnumBloquearContratos } from "model/enums/enum-bloquear-contratos";
import { EnumTipoCobrancaRevenda } from "model/enums/enum-tipo-cobranca-revenda";
import { EnumTipoPessoas } from "model/enums/enum-tipo-pessoas";
import { EnumTipoPropagandaPessoa } from "model/enums/enum-tipo-propaganda-pessoa";
import { guidEmpty } from "utils/guid-empty";

export class PessoaModel {
        constructor(
                public id: string = guidEmpty(),
                public tipo: EnumTipoPessoas = EnumTipoPessoas.Cliente,
                public nomeComercial: string = '',
                public cpfCnpj: string = '',
                public status: number = 0,
                public diasLimiteAtrasoClientes: number = 0,
                public valorMinimoFatura: number = 0,
                public login: string | null = null,
                public senha: string | null = null,
                public bloquearContratos: EnumBloquearContratos = EnumBloquearContratos.BloquearContratos,
                public mensagemAosContratos: string = '',
                public revendaId: string | null = null,
                public telefoneSuporte: string | null = null,
                public urlImagem: string = '',
                public revendaNome: string = guidEmpty(),
                public chaveAtivacao: string = '',
                public recebeIndicacoes: number = 0,
                public tipoCobrancaRevenda: EnumTipoCobrancaRevenda = EnumTipoCobrancaRevenda.Revenda,
                public tipoPropaganda: EnumTipoPropagandaPessoa = EnumTipoPropagandaPessoa.NaoExibir,
                public permiteUsoAdquirente: boolean = false,
                public gerenteId: string = '',
                public gerenteNome: string = '',
        ) { }
}